import { DataBean } from "../DataBean";

export class SignList extends DataBean {

    public async deleteSignList(idsignlist: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "boolean_deleteSignList_Number", [idsignlist]);
    }

    public async getSignList(idsignlist: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.orange.finance.processcontract.bean.SignList_getSignList_Number", [idsignlist]);
    }

    public async getSignListCatalogPorPropiedades(properties: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getSignListCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async updateSignList(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.SignList_updateSignList_com.orange.finance.processcontract.bean.SignList",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.SignList"
                }
            ]
        );
    }

}